import React, { useEffect, useState, useCallback, useMemo } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles, styled } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Box,
  CircularProgress,
  Grid,
  IconButton,
} from "@material-ui/core";
import GolfCloseallpark from "../../views/UserDashboard/GolfCloseAll";
import { DirectionsOutlined, MoreVert } from "@material-ui/icons";
import { BsFillBellFill } from "react-icons/bs";
import smartParkService from "../../axios";
import { GenerateEncryptedToken } from "../../views/Common";
import {
  setSelectedField,
  fieldDetailsByType_,
  setFieldCourts,
} from "../../reducers/userDashboard";
import "./admingolfcourse.css";
import Carousel from "react-bootstrap/Carousel";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MdToggleOn, MdToggleOff } from "react-icons/md";
import GolfOpenCloseModal from "../../views/UserDashboard/GolfCloseHoleModal";
import "../../demo.css";

import { object } from "prop-types";
const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    height: "100%",
  },
  notifycsp: {
    fontSize: 13,
  },
  bellicon: {
    fontSize: "1.5rem",
  },
  notificationicon: {
    background: "white",
    display: "flex",
    position: "absolute",
    top: 5,
    zIndex: 99,
    right: 5,
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end",
    cursor: "pointer",
    marginTop: "-70px",
    position: "relative",
    padding: theme.spacing(0, 2),
    height: 60,
  },
  cardContent: {
    paddingTop: 32,
  },
  ht364: {
    height: 373,
    overflowY: "auto",
    paddingBottom: "10px !important",
  },
  actionbtn: {
    position: "absolute",
    bottom: "0",
    width: "100%",
    left: "6px",
    right: "0",
  },
  h5: {
    color: "#fff",
    fontWeight: 600,
    width: "50%",
    marginBottom: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
    textShadow: "-2px 2px 2px #000",
  },
  imgCard: {
    "& .MuiCardContent-root:last-child": {
      paddingBottom: 16,
    },
    "& .MuiCardContent-root": {
      [theme.breakpoints.up("lg")]: {
        height: 487,
      },
    },
  },
  media: {
    height: 200,
    cursor: "default",
    cursor: "pointer",
  },
  customButton: {
    textTransform: "capitalize",
    fontSize: "0.95em",
    fontWeight: 500,
    boxShadow: "none !important",
  },
  titleBtn: {
    background: "#53de21 !important",
    color: "#fff",
    fontWeight: "bold",
    textTransform: "capitalize",
    boxShadow: "none !important",
    borderRadius: 20,
    fontSize: 16,
    width: 100,
  },
  closetext: {
    position: "absolute",
    top: "50%",
    zIndex: "99",
    color: "white",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: "2rem",
  },
}));
const occupiedStyle = {
  borderRadius: 4,
  backgroundColor: "#fec6c6",
  color: "red",
  fontSize: "12px",
  fontWeight: "bold",
};
const unOccupiedStyle = {
  borderRadius: 4,
  backgroundColor: "#b8f0d2",
  color: "#0b9444",
  fontSize: "12px",
  fontWeight: "bold",
};
const listItemContainerStyle = {
  height: "100%",
};
export default function AdminGolfCourseCard(props) {
  const {
    actions,
    allNotify,
    cardType,
    cardStyle = "simple",
    getFields,
    courseData,
  } = props;
  const { refresh, setRefresh } = props;
  // const [selectedCard, setSelectedCard] = useState(null);
  const [fields, setFields] = useState([]);
  const classes = useStyles();
  const [mcparr, setmcparr] = useState([]);
  const [getAllParknotifi, setAllParknotifi] = useState([]);
  // const [getresval, setresval] = useState([]);
  const [getHoleStatus, setHoleStatus] = useState("");
  const [getHoleId, setHoleId] = useState("");
  const [getGolfId, setGolfId] = useState("");
  const [getHoleName, setHoleName] = useState("");
  const [getfinalStatus, setfinalStatus] = useState("");
  const [getTileParkname, setTileParkname] = useState("");
  const [getopenclosep, setopenclosep] = React.useState("");
  const [holeChunks, setholeChunks] = useState([]);
  const [parkopen, setparkopen] = React.useState(false);
  //   const [getHoleStatus, setHoleStatus] = useState("");
  const [openGolfModal, setOpenGolfModal] = useState(false);
  const selectedCard = useSelector((state) =>
    fieldDetailsByType_(state, cardType)
  );
  const dispatch = useDispatch();
  const [closeoverlay, setcloseoverlay] = React.useState(true);
  const [getNotification, setNotification] = React.useState(false);
  const [getparkopenname, setparkopenname] = React.useState([]);
  const [getNotificationRefresh, setNotificationRefresh] =
    React.useState(false);
  const [getNotificationMessage, setNotificationMessage] = React.useState("");
  const [getnotifyWeblink, setnotifyWeblink] = React.useState("");
  const [getnotifyWebname, setnotifyWebname] = React.useState("");
  //   const [getrefresh, setRefresh] = useState(false);
  const parkrealid = "c7a1d85f-8168-4e64-8e38-116a0624bfea";

  // useEffect(() => {
  //   openfn();
  // }, []);

  let getGolfOverlayID = JSON.parse(localStorage.getItem("GolfOverlayID"));
  useEffect(() => {
    let sortCourseData;
    sortCourseData = courseData?.hole_data?.sort(function (a, b) {
      return a.DisplayOrder - b.DisplayOrder;
    });

    let chunkSize = 6;
    let golfholeChunks = [];
    // Divide the hole_data array into chunks of size 6
    for (let i = 0; i < sortCourseData?.length; i += chunkSize) {
      golfholeChunks.push(sortCourseData?.slice(i, i + chunkSize));
    }
    setholeChunks(golfholeChunks);
  }, [courseData]);

  //   useEffect(() => {
  //     notificationFunction();
  //   }, [parkrealid, getNotificationRefresh]);

  function simpledate(date) {
    try {
      const parsedDate = new Date(date);
      const simpleDate = parsedDate.toISOString().split("T")[0];
      return simpleDate;
    } catch {
      return date;
    }
  }

  const notificationFunction = () => {
    if (parkrealid !== "" && parkrealid !== undefined && parkrealid !== null) {
      let url = `api/notification/detail/${parkrealid}`;
      smartParkService
        .get(url)
        .then((res) => {
          if (res.status == 200) {
            setNotification(false);
            if (res.data.status == 200) {
              let allParkdetails = res.data.data;
              if (allParkdetails !== null) {
                let nstartDate = simpledate(allParkdetails.startDate);
                let nendDate = simpledate(allParkdetails.endDate);
                let newdate = simpledate(new Date());
                if (allParkdetails.parkId == parkrealid) {
                  if (newdate >= nstartDate && newdate <= nendDate) {
                    if (allParkdetails.parkId == parkrealid) {
                      setNotificationMessage(allParkdetails.message);
                      setnotifyWeblink(allParkdetails.webLink);
                      setnotifyWebname(allParkdetails.webName);
                      setNotification(true);
                    }
                  } else {
                    setNotification(false);
                  }
                }
              }
            }
          }
        })

        .catch((error) => {
          console.error("Notification error: ", error);
        });
    } else {
      console.log("please Enter all details");
    }
  };

  // console.log(getAllParknotifi);

  function openfn() {
    if (!selectedCard) {
      return;
    }
    smartParkService
      .get("api/park/" + parkrealid + "/facilitiesmanagement")
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          if (res.data.message === false) {
            setcloseoverlay(false);
          } else {
            setcloseoverlay(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // MT-58 issue
  let cardHeights = [];
  // Get all the card elements with the same class
  let cards = document.getElementsByClassName("MuiGrid-grid-md-6");
  // Initialize a variable to store the highest height
  let maxHeight = 0;
  // Loop through each card element
  for (let i = 0; i < cards.length; i++) {
    let card = cards[i];
    // Get the height of the current card
    let height = card.clientHeight;
    // Push the height to the array
    cardHeights.push(height);
    // Update the maxHeight if the current height is greater
    if (height > maxHeight) {
      maxHeight = height;
    }
  }

  for (let i = 0; i < cards.length; i++) {
    let card = cards[i];
    let innerDiv = card.querySelector(".MuiPaper-rounded");
    innerDiv.style.minheight = `${maxHeight}px`;
  }

  const handleClose = () => {
    setOpenGolfModal(false);
    setRefresh((prevRefresh) => !prevRefresh);
  };

  function openclosegolfholes(
    golfid,
    golfholeid,
    golfholestatus,
    holename,
    finalStatus,
    parkn
  ) {
    setHoleStatus(golfholestatus);
    setHoleId(golfholeid);
    setGolfId(golfid);
    setHoleName(holename);
    setfinalStatus(finalStatus);
    setTileParkname(parkn);
    setOpenGolfModal(true);
  }

  function closeallpark(e) {
    let buttonElement = e.currentTarget;
    let buttonText = buttonElement.textContent;
    let finalparkdata = [];
    let allEle = e.currentTarget.closest(".openclosebtnsection");
    let prevsib = allEle.previousSibling;
    let allcardata = prevsib.querySelectorAll(".openclosegrid");
    allcardata.forEach(function (ele) {
      finalparkdata.push({
        fieldname: ele.getAttribute("data-name"),
        fieldstatus: ele.getAttribute("data-status"),
        fieldid: ele.getAttribute("data-id"),
        fieldfinalStatus: ele.getAttribute("data-finalStatus"),
      });
    });
    if (buttonText === "Close All") {
      setopenclosep("Closed");
    } else if (buttonText === "Open All") {
      setopenclosep("Open");
    } else {
      setopenclosep("");
    }
    setparkopenname(finalparkdata);
    setparkopen(true);
  }

  const handleclosepark = () => {
    setparkopen(false);
    setRefresh((r) => !r);
  };

  const funcoverlay = () => {
    setcloseoverlay(false);
  };

  return (
    <>
      <GolfOpenCloseModal
        show={openGolfModal}
        status={getHoleStatus}
        closePopup={handleClose}
        golfid={getGolfId}
        holeid={getHoleId}
        holename={getHoleName}
        finalStatus={getfinalStatus}
        tileparkname={getTileParkname}
      />
      <GolfCloseallpark
        show={parkopen}
        closePopup={handleclosepark}
        pname={getparkopenname}
        parkname={courseData}
        parkopenclose={getopenclosep}
        overlay={funcoverlay}
      />
      {courseData ? (
        cardStyle === "simple" ? (
          <Card elevation={8} className={`${classes.card} sameheight`}>
            <CardActionArea
              className={
                (getGolfOverlayID || []).some(
                  (entry) => entry.golfID === courseData.golfID
                ) &&
                  getGolfOverlayID.find(
                    (entry) => entry.golfID === courseData.golfID
                  )?.status.toLowerCase() === "closed"
                  ? "parkbtn"
                  : "overlaybg"
              }
              onClick={() => {
                if (courseData.name === "Practice Green") {
                  props.handleOpen(courseData);
                }
              }}
            >
              <CardMedia
                className={classes.media}
                image={courseData.img_path}
              />
              {(getGolfOverlayID || []).some(
                (entry) => entry.golfID === courseData.golfID
              ) &&
                getGolfOverlayID.find(
                  (entry) => entry.golfID === courseData.golfID
                )?.status.toLowerCase() === "closed" ? (
                <div className={classes.closetext}>Closed</div>
              ) : (
                ""
              )}

              {getNotification ? (
                <div className="notificationicon">
                  <div className="notify">
                    <BsFillBellFill className="text-danger notifybellicon" />
                  </div>
                </div>
              ) : (
                <></>
              )}
            </CardActionArea>
            <div
              className={classes.cardTitle}
              onClick={() => {
                if (courseData.name === "Practice Green") {
                  props.handleOpen(courseData);
                }
              }}
            >
              <h5 className={classes.h5}>{courseData.name}</h5>
            </div>
            <CardContent className="conheight mb-4">
              <div className="position-relative">
                <h6 className="title1 samesize">Status</h6>
                <div className="golfcarousel">
                  <Carousel
                    fade
                    interval={null}
                    prevIcon={<FaChevronLeft />}
                    nextIcon={<FaChevronRight />}
                  >
                    {holeChunks?.map((chunk, index) => (
                      <Carousel.Item key={index}>
                        <div className="grid-container p-0 admingolf">
                          {chunk?.map((field) => (
                            <div className="itemgolf text-center golfitems">
                              <div
                                className={
                                  field.HoleStatus !== null && field.HoleStatus.toLowerCase() === "closed"
                                    ? `list-item closed openclosegrid`
                                    : field.finalStatus.toLowerCase() ==
                                      "very wet"
                                      ? `list-item openclosegrid verywetcolor`
                                      : field.finalStatus.toLowerCase() == "wet"
                                        ? `list-item openclosegrid wetcolor`
                                        : `list-item open openclosegrid`
                                }
                                style={listItemContainerStyle}
                                key={field.HoleID}
                                data-id={field.HoleID}
                                data-name={field.HoleName}
                                data-status={field.HoleStatus}
                                data-finalStatus={field.finalStatus}
                                golfname={courseData.name}
                                onClick={() =>
                                  openclosegolfholes(
                                    field.golfID,
                                    field.HoleID,
                                    field.HoleStatus,
                                    field.HoleName,
                                    field.finalStatus,
                                    courseData.name
                                  )
                                }
                              >
                                <span className="listItemSpanStyle w-100">
                                  <div className="listItemSpanDivStyle">
                                    {field.HoleName}
                                  </div>
                                </span>
                                <label className={`listItemLabelStyle  `}>
                                  {field.HoleStatus !== null && field.HoleStatus.toLowerCase() == "open" &&
                                    field.finalStatus !== ""
                                    ? field.finalStatus
                                    : field.HoleStatus !== null && field.HoleStatus}
                                </label>
                                {field.HoleID ? (
                                  field.HoleStatus !== null && field.HoleStatus.toLowerCase() === "open" ? (
                                    <div className="greentoggle">
                                      <MdToggleOn />
                                    </div>
                                  ) : (
                                    <div className="redtoggle">
                                      <MdToggleOff />
                                    </div>
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  {!courseData.hole_data.length ? (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress />
                    </Box>
                  ) : null}
                </div>
              </div>
            </CardContent>
            <CardActions
              className={`${classes.actionbtn} openclosebtnsection `}
            >
              {actions ? (
                <div className="adminbtnaction">
                  {courseData.name == "Practice Green" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.customButton}
                      onClick={() => {
                        props.handleOpen(courseData);
                      }}
                    >
                      Advanced Settings
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled
                      className={classes.customButton}
                    >
                      Advanced Settings
                    </Button>
                  )}
                  {(getGolfOverlayID || []).some(
                    (entry) => entry.golfID === courseData.golfID
                  ) &&
                    getGolfOverlayID.find(
                      (entry) => entry.golfID === courseData.golfID
                    )?.status.toLowerCase() === "closed" ? (
                    <Button
                      color="primary"
                      className={`openclosebtn ${classes.customButton}`}
                      onClick={closeallpark}
                    //   disabled={isdisabled}
                    >
                      Open All
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      className={`openclosebtn ${classes.customButton}`}
                      onClick={closeallpark}
                    //   disabled={isdisabled}
                    >
                      Close All
                    </Button>
                  )}
                </div>
              ) : (
                ""
              )}
              {allNotify ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.customButton}
                >
                  All Notifications
                </Button>
              ) : (
                ""
              )}
            </CardActions>
          </Card>
        ) : (
          <>
            <Grid item xs={12} sm={12} md={4}>
              <Card elevation={8} className="sameheightcard">
                <CardHeader
                  title={courseData.name}
                  className="text-center"
                ></CardHeader>
                <CardContent className={classes.ht364}>
                  <div>
                    <h6 className="title1 samesize">Status</h6>
                    <ul className="status-list">
                      {courseData.hole_data.map((field, idx) => (
                        // <li key={field.fieldId}>
                        <li key={field.HoleID + idx}>
                          <span>{field.HoleName}</span>
                          <label
                            className={
                              field.HoleStatus !== null && field.HoleStatus.toLowerCase() == "closed" ? `closed` : `open`
                            }
                            style={{ textTransform: "uppercase" }}
                          >
                            {field.HoleStatus !== null && field.HoleStatus.toLowerCase() == "open" &&
                              field.finalStatus !== ""
                              ? field.finalStatus
                              : field.HoleStatus !== null && field.HoleStatus}
                          </label>
                        </li>
                      ))}

                      {!courseData.hole_data.length ? (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <CircularProgress />
                        </Box>
                      ) : null}
                    </ul>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Card elevation={8} className={classes.imgCard}>
                <CardContent>
                  <img
                    src={courseData.img_path}
                    alt="map"
                    width="100%"
                    height="455px"
                    className="parkimg"
                  />
                </CardContent>
              </Card>
            </Grid>
          </>
        )
      ) : (
        <></>
      )}
    </>
  );
}
AdminGolfCourseCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  actions: PropTypes.bool,
  allNotify: PropTypes.bool,
  refresh: PropTypes.bool,
};
